import React from 'react';
import { BasicInput } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { InputContainer } from './StyledComponents';
import { ContactDetailsInputProps } from '../AddInterface';

export const ContactDetailsInput = (props: ContactDetailsInputProps): JSX.Element => {
    const { name, setAddContactParam, value, emailError, errorMessage } = props;
    const { t } = useTranslation();

    return (
        <InputContainer>
            <BasicInput
                id={`contact-${name}-input`}
                label={t(name)}
                value={value || ''}
                error={emailError}
                errorMessage={t(errorMessage)}
                onChange={(event) => {
                    setAddContactParam(name, event.currentTarget.value);
                }}
            />
        </InputContainer>
    );
};
